"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupBy = void 0;
var chart_types_1 = require("../chart_types");
var spec_factory_1 = require("../state/spec_factory");
var constants_1 = require("./constants");
var DEFAULT_GROUP_BY_PROPS = {
    chartType: chart_types_1.ChartType.Global,
    specType: constants_1.SpecType.IndexOrder,
};
exports.GroupBy = spec_factory_1.getConnect()(spec_factory_1.specComponentFactory(DEFAULT_GROUP_BY_PROPS));
//# sourceMappingURL=group_by.js.map